var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 49H16.1732C14.7596 49 14.0528 49 13.7256 48.7205C13.4416 48.4779 13.2909 48.1141 13.3202 47.7418C13.3539 47.3127 13.8537 46.8129 14.8533 45.8134L34.6935 25.9732C35.6175 25.0492 36.0795 24.5871 36.6123 24.414C37.0809 24.2618 37.5857 24.2618 38.0544 24.414C38.5871 24.5871 39.0492 25.0492 39.9732 25.9732L49 35V37.8M37.8 49C41.7204 49 43.6806 49 45.1779 48.237C46.4951 47.5659 47.5659 46.4951 48.237 45.1779C49 43.6806 49 41.7204 49 37.8M37.8 49H18.2C14.2796 49 12.3194 49 10.8221 48.237C9.50493 47.5659 8.43407 46.4951 7.76295 45.1779C7 43.6805 7 41.7204 7 37.8V18.2C7 14.2796 7 12.3194 7.76295 10.8221C8.43407 9.50493 9.50493 8.43407 10.8221 7.76295C12.3194 7 14.2796 7 18.2 7H37.8C41.7204 7 43.6805 7 45.1779 7.76295C46.4951 8.43407 47.5659 9.50493 48.237 10.8221C49 12.3194 49 14.2796 49 18.2V37.8M24.5 19.8333C24.5 22.4107 22.4107 24.5 19.8333 24.5C17.256 24.5 15.1667 22.4107 15.1667 19.8333C15.1667 17.256 17.256 15.1667 19.8333 15.1667C22.4107 15.1667 24.5 17.256 24.5 19.8333Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGrey);
export default __webpack_public_path__ + "static/media/image-grey.2a77d2d11be10d185473083ce515a06b.svg";
export { ForwardRef as ReactComponent };